import { Box, Flex, FlexProps } from 'styled-system/jsx';

type PercentageSplitLineProps = FlexProps & {
  firstLinePercentage: number; // need to be between 0 and 100
  secondLinePercentage?: number;
};
// TODO: refactor to accept decimals value
export const PercentageSplitLine: React.FC<PercentageSplitLineProps> = ({
  firstLinePercentage,
  secondLinePercentage,
  ...props
}) => {
  return (
    <Flex width="100%" alignItems="center" justifyContent="center" {...props}>
      <Box
        h="1px"
        backgroundColor="price.priceUp"
        style={{
          width: `${firstLinePercentage}%`,
        }}
      />
      <Box
        h="1px"
        backgroundColor="price.priceDown"
        mt="1px" // have Poggendorff illusion, check here: https://en.wikipedia.org/wiki/Poggendorff_illusion , adding one extra 1px will make it visually align (without it will be physically align but looks not)
        style={{
          width: `${secondLinePercentage ?? 100 - firstLinePercentage}%`,
        }}
      />
    </Flex>
  );
};
